<template>
  <div>
    <partners-controls v-show="false" :cities="cities" :grades="grades" :search="search" :current-grade="currentGrade" :current-city="currentCity" @filterCity="filterCity" @filterGrade="filterGrade" @search="debounceSearch"></partners-controls>
    <div v-if="paginatedItems.length !== 0 || partner">
    <ul class="tw-grid tw-gap-6 md:tw-gap-5 md:tw-grid-cols-2 tw-mt-6">
      <li>
        <partner-item :id="partner.id" :partner-data="partner"></partner-item>
      </li>
    </ul>
    <button v-if="paginatedItems.length < filteredItems.length" @click="currentPage++" class="tw-w-full tw-h-11 tw-border tw-border-[#D6D6D6] tw-text-[#0D4A75] tw-text-center tw-mt-5 tw-transition-all hover:tw-drop-shadow-lg">
      Show more
    </button>
    </div>
    <div v-else class="tw-mt-4 md:tw-text-center">
      No Partners
    </div>
  </div>
</template>

<script>
import PartnerItem from './PartnerItem.vue'
import PartnersControls from "./PartnersControls.vue";
import {partner} from "../../constants/partner";
export default {
  name: "PartnersList",
  components: {PartnersControls, PartnerItem},
  data() {
    return {
      items: [],
      cities: [],
      filteredItems: [],
      limit: 6,
      currentPage: 1,
      currentGrade: null,
      currentCity: 0,
      search: '',
      debounce: null,
      partner,
      grades: [
        {name: 'Платиновый', value: 'Платиновый партнер'},
        {name: 'Золотой', value: 'Золотой партнер'},
        {name: 'Серебряный', value: 'Серебряный партнер'},
        {name: 'Бронзовый', value: 'Бронзовый партнер'},
        {name: 'Сертифицированный', value: 'Сертифицированный партнер'}
      ]
    }
  },
  computed: {
    paginatedItems() {
      return this.filteredItems.slice(0, this.limit * this.currentPage)
    }
  },
  methods: {
    getPartners() {
      fetch(`/en/partners.json`)
        .then((response) => response.json())
        .then((data) => {
          this.items = data.sort(this.sortFunction);
          this.cities = this.uniq(data)
          this.filterItems()
        });
    },
    uniq(array) {
      const cities = array.map(el => el.city)
      const citiesSet = Array.from(new Set(cities.map(el => el.id)))
      return citiesSet.map(el => cities.find(el1 => el1.id === el))
    },
    filterCity(city) {
      this.currentCity !== city ? this.currentCity = city : this.currentCity = 0
      this.filterItems()
    },
    filterGrade(grade) {
      this.currentGrade !== grade? this.currentGrade = grade : this.currentGrade = null
      this.filterItems()
    },
    sortFunction(a, b) {
      if (this.grades.map(e => e.value).indexOf(a.grade) > this.grades.map(e => e.value).indexOf(b.grade)) {
        return 1;
      }
      if (this.grades.map(e => e.value).indexOf(a.grade) < this.grades.map(e => e.value).indexOf(b.grade)) {
        return -1;
      }
      return 0;
    },
    filterItems() {
      let filtered = []
      if (this.currentCity && this.currentGrade !== null) {
        filtered = this.items.filter(el => el.city.id === Number(this.currentCity) && el.grade === this.grades[this.currentGrade].value)
        if (Number(this.currentCity) === 1384) {
          filtered.push(this.items.find(el => el.id === 227))
        } else if (Number(this.currentCity) === 2521) {
          filtered.push(this.items.find(el => el.id === 252))
        }
      } else if (this.currentCity) {
        filtered = this.items.filter(el => el.city.id === Number(this.currentCity))
        if (Number(this.currentCity) === 1384) {
          filtered.push(this.items.find(el => el.id === 227))
        } else if (Number(this.currentCity) === 2521) {
          filtered.push(this.items.find(el => el.id === 252))
        }
      } else if (this.currentGrade !== null) {
        filtered = this.items.filter(el => el.grade === this.grades[this.currentGrade].value)
      } else {
        filtered = this.items
      }
      if (this.search) {
        filtered = filtered.filter(el => el.name.toLowerCase().trim().includes(this.search.toLowerCase().trim()))
      }
      this.filteredItems = filtered
    },
    debounceSearch(value) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.search = value
        this.filterItems()
      }, 300)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partners/PartnersList.vue